<template>
	<div v-if="chance_list.length">
		<!-- 关联回款 -->
		<div class="gl_tit">
			关联回款

		</div>
		<div class="gl_list">

			<div class="shangji" v-for="(item, index) in chance_list">

				<!-- <div class="delebtn" @click="delebtn(index)">
					<i class="el-icon-delete"></i>
				</div> -->

				<div class="sj_name">
					{{ item.hk_code || '' }}
				</div>
				<div class="sj_qyname" v-if="item.customer_name">

					<div class="txt FlexRow">
						<img :src="urlhead + '/renz1.png'">
						{{ item.customer_name || '' }}
					</div>
				</div>

				<div class="sj_state">
					<div class="state state3" v-if="item.return_nature == 1">
						收款
					</div>
					<div class="state state3" v-else>
						预收款
					</div>

					<div class="state state3" v-if="item.audit_status == 0">
						待审核
					</div>
					<div class="state state1" v-else-if="item.audit_status == 1">
						已确认
					</div>
					<div class="state state2" v-else>
						拒绝
					</div>
				</div>

				<div class="sj_bottom">
					<div class="sj_text"></div>
					<div class="sj_btmfont">
						<div class="fonts FlexRow">
							负责人：{{ item.member_name || '' }}
						</div>
						<div class="fonts FlexRow">
							合同金额：
							<span v-if="item.amount">
								￥{{ item.amount || 0 }}
							</span>
						</div>
					</div>
					<div class="sj_btmfont">
						<div class="fonts FlexRow">
							回款日期：
							<span v-if="item.return_time">
								{{ item.return_time || '' }}
							</span>
						</div>
						<div class="fonts FlexRow">
							回款金额：
							<span v-if="item.huikuan">
								￥{{ item.huikuan || 0 }}
							</span>
						</div>
					</div>
					<div class="sj_btmfont">
						<div class="fonts FlexRow">
							合同源单：
							<span v-if="item.contract_name">
								{{ item.contract_name || '' }}
							</span>
						</div>

					</div>

				</div>



			</div>
		</div>

	</div>
</template>

<script>
var that
import {


	gchance_list,

	hkl_list_return,
	xmde_list,
	get_contracTlist,

	xmde_del,

	del_business_chance,
	hkl_del_return,
} from 'network/hk_operset'


export default {
	name: "relationchance",
	props: {


		contract_id: {
			type: Number,
			default: 0,
		},
		order_id: {
			type: Number,
			default: 0,
		},
		customer_id: {
			type: Number,
			default: 0,
		},
		
		

	},
	data() {
		return {
			//

			urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
			chance_list: [],


		}
	},
	watch: {
		order_id(){
			this.getlists()
		},
	},
	created() {
		that = this

		this.getlists()


	},

	methods: {



		getlists() {

			let data = {
				pagesize: 999,

			}
			if (this.contract_id) {
				data.contract_id = this.contract_id
			}
			if (this.order_id) {
				data.order_id = this.order_id
			}
			if (this.customer_id) {
				data.customer_id = this.customer_id
			}
			hkl_list_return(data).then(res => {
				if (this.handlereq(res)) {
					this.handle_data2(res.result.data)
					// this.chance_list = res.result.data
				}
			})
		},

		handle_data2(data) {
			if (data) {
				for (let item of data) {
					if (item.return_time) {
						item.return_time = item.return_time.slice(0, 10)
					}
					if (item.return_info && typeof (item.return_info) == 'string') {
						let newArr = JSON.parse(item.return_info)
						if (newArr.length > 0) {
							let index = newArr.findIndex(v => v.field_sign == '合同金额')
							if (index != -1) {
								item.amount = newArr[index].content;
							}
							let index2 = newArr.findIndex(v => v.field_sign == '回款金额')
							if (index2 != -1) {
								item.huikuan = newArr[index2].content || 0;
							}
						}
					}


					item.checked = false


				}



				this.$nextTick(() => {
					this.chance_list = data
					console.log(this.chance_list, 'chance_list')
				})

			}
		},
		delebtn(index) {
			let return_id = this.chance_list[index].return_id
			this.release_gh(return_id)
		},



		release_gh(return_ids) {
			this.$confirm('您确定要删除吗?')
				.then(() => {
					hkl_del_return(return_ids).then(res => {
						if (this.handlereq(res)) {
							this.alertMess('删除成功', 'success')
							this.getlists()
						}

					})
				}).catch(() => { });

		},
		// 删除




		// 弹出提示
		alertMess(message, type) {
			this.$message({
				showClose: true,
				offset: 100,
				duration: 2000,
				message,
				type: type ? type : 'success',
			});
		},
		handlereq(res) {
			if (res) {
				if (res.code === 10000) { // 请求成功
					return true
				} else { // 请求发生错误
					this.alertMess(res.message, 'error')
					return false
				}
			}
		},




	}
}
</script>

<style scoped lang="scss">
.gl_list {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 30px;

}

.shangji::before {
	content: '';
	display: block;
	position: absolute;
	width: 294px;
	height: 7px;
	bottom: 0;
	left: 0;
	z-index: 3;
	background: rgba(42, 117, 234, 1);
}

.shangji::after {
	content: '';
	display: block;
	position: absolute;
	width: 100%;
	height: 7px;
	bottom: 0;
	left: 0;
	z-index: 2;
	background: rgba(212, 227, 252, 1);
}

.shangji {
	position: relative;
	width: 344px;
	// height: 235px;
	// height: 208px;
	border: 1px solid rgba(220, 223, 230, 1);
	border-bottom: none;
	padding: 25px;
	margin: 0 20px 20px 0;

	.delebtn {
		position: absolute;
		right: 40px;
		cursor: pointer;
		top: 20px;

		i {
			color: #666;
			font-size: 15px;
		}
	}

	.sj_name {
		font-size: 16px;
		font-weight: 550;
		color: rgba(56, 56, 56, 1);
		margin-bottom: 10px;
	}

	.sj_qyname {
		margin-bottom: 10px;
		display: flex;
		align-items: center;

		.tit {
			font-size: 14px;
			color: rgba(56, 56, 56, 1);
			margin-right: 5px;
		}

		.txt {
			font-size: 12px;
			color: rgba(150, 150, 150, 1);

			img {
				width: 15px;
				height: 15px;
				display: block;
				margin-right: 6px;
			}
		}
	}

	.sj_state {
		margin-bottom: 10px;
		display: flex;
		align-items: center;

		.state {
			height: 20px;
			padding: 0 10px;
			border-radius: 3px;
			font-size: 12px;
			margin-right: 7px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.state1 {
			color: rgba(82, 196, 26, 1);
			background: rgba(235, 255, 236, 1);
		}

		.state2 {
			color: rgba(255, 125, 0, 1);
			background: rgba(249, 237, 217, 1);
		}

		.state3 {
			color: rgba(43, 117, 235, 1);
			background: rgba(235, 241, 255, 1);
		}
	}

	.sj_bottom {
		border-top: 1px solid rgba(246, 246, 246, 1);
		padding-top: 20px;

		.sj_text {
			font-size: 13px;
			color: rgba(150, 150, 150, 1);
			margin-bottom: 8px;
		}

		.sj_btmfont {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 8px;

			.fonts {
				flex: 1;
				white-space: nowrap;
				justify-content: flex-start;
				font-size: 12px;
				color: rgba(150, 150, 150, 1);
			}
		}
	}
}

.gl_tit::before {
	content: '';
	display: block;
	width: 3px;
	height: 20px;
	background: rgba(43, 117, 235, 1);
	margin-right: 8px;
}

.gl_tit {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 550;
	margin-bottom: 18px;
	color: rgba(56, 56, 56, 1);

	.gl_btn {
		width: 75px;
		height: 27px;
		border-radius: 3px;
		background: rgba(42, 117, 234, 1);
		font-size: 14px;
		cursor: pointer;
		color: #fff;
		margin-left: 10px;

		i {
			color: #fff;
			font-size: 14px;
		}
	}
}
</style>
